var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 26,
    viewBox: "0 0 12 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3_446)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.3346 6.57144V18.8929C10.3346 21.2607 8.34568 23.1786 5.89013 23.1786C3.43457 23.1786 1.44568 21.2607 1.44568 18.8929V5.50001C1.44568 4.02144 2.69013 2.82144 4.22346 2.82144C5.75679 2.82144 7.00124 4.02144 7.00124 5.50001V16.75C7.00124 17.3393 6.50124 17.8214 5.89013 17.8214C5.27902 17.8214 4.77901 17.3393 4.77901 16.75V6.57144H3.11235V16.75C3.11235 18.2286 4.35679 19.4286 5.89013 19.4286C7.42346 19.4286 8.6679 18.2286 8.6679 16.75V5.50001C8.6679 3.13215 6.67902 1.21429 4.22346 1.21429C1.7679 1.21429 -0.220985 3.13215 -0.220985 5.50001V18.8929C-0.220985 22.15 2.51235 24.7857 5.89013 24.7857C9.2679 24.7857 12.0012 22.15 12.0012 18.8929V6.57144H10.3346Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3_446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 25.7143,
    fill: "white",
    transform: "translate(0 0.142853)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachFile);
export default __webpack_public_path__ + "static/media/attachFile.04391da9b9b3c19cc2e224be7a8fc13e.svg";
export { ForwardRef as ReactComponent };